// Module
var code = "<div class=\"container\"> <div class=\"block-title\">Shouts</div> <div class=\"bordered-block ng-hide\" ng-show=\"shouts\"> <shouts-controller></shouts-controller> </div> </div> ";
// Exports
module.exports = code;